import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../language/vn';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {CommandUtil} from '../../../global/commandutil';

import {BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import {ConfirmDialogComponent} from '../../dialog/confirmdialog.component';
import {environment} from '../../../../environments/environment';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import {DangKy} from '../../../models/vpp/dangky';
import {ThietBi} from '../../../models/danhmuc/thietbi';
import {DangKyService} from '../../../service/vpp/service-dangky';
import {ThietBiService} from '../../../service/danhmuc/service-thietbi';
import {Sessioncommand} from '../../../global/sessioncommand';
import {EditDangKyComponent} from './edit.component';
import {ConfirmPDDangKyComponent} from './confirmpd.component';
import {DetailDangKyPhongComponent} from '../phonghop/detail.component';
import {DetailDangKyComponent} from './detail.component';

@Component({
  templateUrl: './duyet.component.html',
  encapsulation: ViewEncapsulation.None
})
export class VPPDuyetDangKyComponent implements OnInit, AfterViewInit {
  public language = language;
  public totalItems: number = 0;
  public hoSoId:  number;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public frmGroup: FormGroup;
  public dataList: DangKy[];
  public srTitle: string = '';
  public srThietBi: number = -1;
  public dataThietBi: ThietBi[];
  constructor( public dangKyService: DangKyService,
               public formBuilder: FormBuilder,
               public toastr: ToastrService,
               public bsModalService: BsModalService,
               public thietBiService: ThietBiService,
               public commandUtil: CommandUtil

  ) {
  }
  ngAfterViewInit() {

  }
  ngOnInit(): void {
    this.search();
    this.thietBiService.getAll().subscribe(data => this.dataThietBi = data);

  }

  public showConfirmationModal(id: number): void {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.confirm_delete_question,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
        this.deleteItem(id);
      }
    });
  }
  get f() { return this.frmGroup.controls; }
  public approved(id: number, tt: number): void {
    if(tt !== 3) {
      const modalEdit = this.bsModalService.show(ConfirmPDDangKyComponent, {class: 'modal-lg'});
      (<ConfirmPDDangKyComponent>modalEdit.content).edit(
        id
      );
      (<ConfirmPDDangKyComponent>modalEdit.content).onClose.subscribe(result => {
        if (result === true) {
          this.search();

        }
      });
    }else
    {
      this.toastr.error(language.message_error_approve, language.message);
    }
  }
  public detail(id: number): void {
    const modalEdit = this.bsModalService.show(DetailDangKyComponent, {class: 'modal-lg'});
    (<DetailDangKyComponent>modalEdit.content).edit(
      id
    );
    (<ConfirmPDDangKyComponent>modalEdit.content).onClose.subscribe(result => {

    });
  }
  public edit(id: number): void {
    const modalEdit = this.bsModalService.show(EditDangKyComponent, {class: 'modal-lg'});
    (<EditDangKyComponent>modalEdit.content).edit(
      id
    );
    (<EditDangKyComponent>modalEdit.content).onClose.subscribe(result => {
      if (result === true) {
        this.search();

      }
    });
  }
  search()
  {

    this.dangKyService.findAllByPheDuyetPaging(this.srTitle, this.srThietBi, '-1', Sessioncommand.staffId, this.currentPage, this.maxSize).subscribe(dataList => this.dataList = dataList);
    this.dangKyService.getCountByPheDuyet(this.srTitle, this.srThietBi, '-1', Sessioncommand.staffId).subscribe(recordCount => this.totalItems = recordCount);
  }

  deleteItem(id: number)
  {
    this.dangKyService.delete(id).subscribe({
      next: () => {
        this.toastr.success(language.delete_success_record, language.message);
        this.search();


      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }

  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.search();

  }

}

